import { render } from "./Crops.vue?vue&type=template&id=57968e42"
import script from "./Crops.vue?vue&type=script&lang=js"
export * from "./Crops.vue?vue&type=script&lang=js"

import "./Crops.vue?vue&type=style&index=0&id=57968e42&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__